import React from "react";
import { string, oneOfType, number, objectOf, object, shape, array, oneOf, func } from "prop-types";
import cx from "classnames";
// eslint-disable-next-line import/no-cycle
import { Card } from "../../../../sharedComponents/Card";
import { Star } from "../Star";
import * as styles from "./HotelCardHorizontal.module.scss";

const HotelCardHorizontal = ({
	image,
	header,
	link,
	className,
	style,
	location,
	stars,
	button,
}) => (
	<Card className={cx(styles.secondary, className, styles.horizontal)} style={style}>
		{image && <Card.Image className={cx(styles.image)} src={image.src} alt={image.alt} />}
		<Card.BodyContainer className={cx(styles.contentContainer)}>
			<Card.Header className={cx(styles.heading)}>{header}</Card.Header>
			<Card.Subheader className={cx(styles.subheading)}>
				<span className={cx(styles.star)}>
					{/* eslint-disable-next-line react/no-array-index-key */}
					{stars && [...Array(Math.floor(stars))].map((j, i) => <Star key={i + j} />)}
				</span>
				{location && location}
			</Card.Subheader>
			{button && (
				<Card.Button to={button.to} icon={button.icon} className={cx(styles.btn)}>
					{button.text}
				</Card.Button>
			)}
			{link && (
				<Card.Link className={cx(styles.link)} to={link.to} target={link.target}>
					{link.text}
				</Card.Link>
			)}
		</Card.BodyContainer>
	</Card>
);

HotelCardHorizontal.propTypes = {
	image: shape({
		fluid: oneOfType([object, array]),
		fixed: oneOfType([object, array]),
		source: shape({
			src: string,
			srcSet: string,
			sizes: string,
		}),
		alt: string,
		src: string,
	}),
	header: string.isRequired,
	location: string,
	link: shape({
		to: string.isRequired,
		target: string,
		icon: shape({
			svg: shape({
				content: string,
			}),
		}),
		text: string,
	}),
	className: string,
	stars: number,
	button: shape({
		icon: string,
		iconPlacement: oneOf(["right", "left"]),
		onClick: func,
		text: string,
	}),
	style: objectOf(oneOfType([string, number])),
};

HotelCardHorizontal.defaultProps = {
	image: null,
	className: "",
	link: null,
	style: {},
	location: null,
	stars: null,
	button: null,
};

export default HotelCardHorizontal;
export { HotelCardHorizontal };
